import { render, staticRenderFns } from "./itemMore.vue?vue&type=template&id=b93a3cf4&scoped=true&"
import script from "./itemMore.vue?vue&type=script&lang=js&"
export * from "./itemMore.vue?vue&type=script&lang=js&"
import style1 from "./itemMore.vue?vue&type=style&index=1&id=b93a3cf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93a3cf4",
  null
  
)

export default component.exports